import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TransactionFiltersProps {
  transactionType: string;
  setTransactionType: (value: string) => void;
  dateRange: string;
  setDateRange: (value: string) => void;
}

export const TransactionFilters = ({
  transactionType,
  setTransactionType,
  dateRange,
  setDateRange
}: TransactionFiltersProps) => {
  return (
    <div className="flex gap-4">
      <Select onValueChange={setTransactionType} value={transactionType}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Transaction Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="withdrawal">Withdrawals</SelectItem>
          <SelectItem value="deposit">Deposits</SelectItem>
          <SelectItem value="payment">Payments</SelectItem>
        </SelectContent>
      </Select>
      <Select onValueChange={setDateRange} value={dateRange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Date Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Time</SelectItem>
          <SelectItem value="7days">Last 7 Days</SelectItem>
          <SelectItem value="30days">Last 30 Days</SelectItem>
          <SelectItem value="90days">Last 90 Days</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};